import { render } from "./LabelingBuild.vue?vue&type=template&id=204c4ad2&ts=true"
import script from "./LabelingBuild.vue?vue&type=script&lang=ts"
export * from "./LabelingBuild.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__